/**
 * Mapa permissão -> rota inicial (ordem = prioridade no pós-login).
 */
export const PERMISSION_HOME_PATHS = [
  { permission: 'dashboard', path: '/' },
  { permission: 'reposicoes', path: '/reposicoes' },
  { permission: 'estoque', path: '/estoque' },
  { permission: 'complementos', path: '/complementos-materiais' },
  { permission: 'rotas', path: '/rotas' },
  { permission: 'preventivas', path: '/preventivas' },
  { permission: 'mapa_tecnicos', path: '/mapa-tecnicos' },
  { permission: 'clientes', path: '/clientes' },
  { permission: 'carros', path: '/carros' },
  { permission: 'tipos_servico_rota', path: '/tipos-servico-rota' },
  { permission: 'relatorios', path: '/relatorios' },
  { permission: 'relatorios_manutencao', path: '/relatorios-manutencao' },
  { permission: 'pesquisas', path: '/pesquisas' },
  { permission: 'usuarios', path: '/usuarios' },
  { permission: 'funcoes', path: '/funcoes' },
  { permission: 'config', path: '/config' },
];

/**
 * Primeira rota que o usuário pode abrir.
 * Sem permissões (lista vazia/ausente) = acesso total → dashboard.
 */
export function getHomePathForPermissoes(permissoes) {
  if (!permissoes || !Array.isArray(permissoes) || permissoes.length === 0) {
    return '/';
  }
  for (const item of PERMISSION_HOME_PATHS) {
    if (permissoes.includes(item.permission)) {
      return item.path;
    }
  }
  return '/login';
}

export function pathAllowedForPermissoes(pathname, permissoes) {
  if (!permissoes || !Array.isArray(permissoes) || permissoes.length === 0) {
    return true;
  }
  // resolve permission key like App.js
  let permission = null;
  const exact = {
    '/': 'dashboard',
    '/rotas': 'rotas',
    '/rotas/nova': 'rotas',
    '/preventivas': 'preventivas',
    '/mapa-tecnicos': 'mapa_tecnicos',
    '/clientes': 'clientes',
    '/usuarios': 'usuarios',
    '/funcoes': 'funcoes',
    '/carros': 'carros',
    '/tipos-servico-rota': 'tipos_servico_rota',
    '/estoque': 'estoque',
    '/reposicoes': 'reposicoes',
    '/relatorios': 'relatorios',
    '/relatorios-manutencao': 'relatorios_manutencao',
    '/pesquisas': 'pesquisas',
    '/relatorios-manutencao-m8': 'relatorios_manutencao',
    '/complementos-materiais': 'complementos',
    '/config': 'config',
  };
  if (exact[pathname]) permission = exact[pathname];
  else if (pathname.startsWith('/rotas/')) permission = 'rotas';
  else if (pathname.startsWith('/relatorios-manutencao/')) permission = 'relatorios_manutencao';

  if (!permission) return true;
  return permissoes.includes(permission);
}
